import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { HashRouter, Route, Routes } from 'react-router-dom';
import './Assets/Css/bootstrap.min.css';
import './Assets/Css/style.css';
import './Assets/Css/plugins.css';
import './Assets/Css/fontawesome.min.css';
import "react-toastify/dist/ReactToastify.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <HashRouter>
    <Routes>
      <Route path='/*' element={<App />} />
    </Routes>
  </HashRouter>
);
